export default "__VITE_ASSET__f446f898__"